<template>
  <n-form-item label="Default Commission" path="defaultCommission" :label-props="{ for: 'defaultCommission' }">
    <n-input-number
      :value="value"
      placeholder="10"
      type="number"
      :min="0"
      :max="100"
      :input-props="{ id: 'defaultCommission' }"
      @update:value="onUpdate"
    >
      <template #suffix> % </template>
    </n-input-number>
  </n-form-item>
</template>

<script setup lang="ts">
defineProps<{ value: number | null }>();
const emit = defineEmits<{
  (e: 'update', value: number | null): void;
}>();

const onUpdate = (value: number | null) => {
  emit('update', value);
};
</script>

<style scoped></style>
